/**
 * @generated SignedSource<<a943ce5e71518ad2fa2f556fb296e70e>>
 * @relayHash 4eea0357b0c46bdca044a6b3b9b301ec
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c9a17fe744f7014b84fa0265289a77140bedf705796685c18a7cc805136059b2

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type ConvertPageToFolderDialogConvertPageToFolderMutation$variables = {
  id: string;
};
export type ConvertPageToFolderDialogConvertPageToFolderMutation$data = {
  readonly convertToFolder: {
    readonly content: {
      readonly id: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type ConvertPageToFolderDialogConvertPageToFolderMutation = {
  response: ConvertPageToFolderDialogConvertPageToFolderMutation$data;
  variables: ConvertPageToFolderDialogConvertPageToFolderMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "ConfluenceConvertContentToFolderPayload",
    "kind": "LinkedField",
    "name": "convertToFolder",
    "plural": false,
    "selections": [
      {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "id"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ConvertPageToFolderDialogConvertPageToFolderMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ConvertPageToFolderDialogConvertPageToFolderMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "4eea0357b0c46bdca044a6b3b9b301ec",
    "id": "c9a17fe744f7014b84fa0265289a77140bedf705796685c18a7cc805136059b2",
    "metadata": {},
    "name": "ConvertPageToFolderDialogConvertPageToFolderMutation",
    "operationKind": "mutation",
    "text": "mutation ConvertPageToFolderDialogConvertPageToFolderMutation($id:ID!){convertToFolder(id:$id){content{id}}}"
  }
};
})();

(node as any).hash = "9e061c22a3f4cc67b35d81eed7b18a16";

export default node;
